<template>
  <div class="detail">
    <TopBack :title="$t('lang.menu.AboutUs')" style="margin-top: 66px;"/>
    <div class="detailContainer">
      <div v-for="(item, index) in aboutUsList" :key="index" :class="item.class" v-html="item.content"></div>
      <div class="bottomLogo">
        <img class="logo" :src="logo" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import logo from '@/assets/images/common/logo1.svg'
import permit from '@/assets/images/common/permit.png'

export default {
  name: 'Privacy',
  data () {
    return {
      logo,
      permit,
      aboutUsList: this.$t('lang.aboutUs')
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.aboutUsList = this.$t('lang.aboutUs')
    }
  },
  components: {
    TopBack
  }
}
</script>

<style lang="less" scoped>
  .detail {
    height: 80vh;
    .detailContainer {
      height: 100%;
      overflow: auto;
      margin-top: 22px;
      padding: 0 16px;
      .t1 {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t2 {
        font-size: 14px;
        line-height: 140%;
        color: #fff;
        margin-bottom: 12px;
      }
      .t3 {
        display: flex;
        font-size: 16px;
        line-height: 19px;
        color: #fff;
        margin-bottom: 10px;
        i {
          margin-left: 10px;
        }
      }
      .bottomLogo {
        display: flex;
        width: 100%;
        overflow: hidden;
        justify-content: flex-end;
        align-items: center;
        text-align: right;

        .logo {
          height: 7.222vw;
        }

        .permit {
          height: 8vw;
          margin-right: 2vw;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/AboutUs.vue